import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as ROUTES from '../../constants/routes';
import './styles.css';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="notfound-container">
      <div className="notfound-glass-card">
        <div className="notfound-blueprint-overlay" />
        <div className="notfound-content">
          <div className="notfound-error-code">404</div>
          <h1 className="notfound-title">
            {t('notfound.title')}
          </h1>
          <p className="notfound-subtitle">
            {t('notfound.subtitle')}
          </p>

          <div className="notfound-actions">
            <button
              onClick={() => navigate(-1)}
              className="notfound-btn secondary-btn"
            >
              ← {t('notfound.back')}
            </button>
            <button
              onClick={() => navigate(ROUTES.HOME)}
              className="notfound-btn primary-btn"
            >
              {t('notfound.home')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
